import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Escandallo/cambiarEstadoEscandalloSeleccion`, method: 'POST', body: values, token: token})
}